import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import Button from '@material-ui/core/Button';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';
import { connect } from 'react-redux';
import {
  addPathologistToTempAssignment,
  addPathologistToTempUnassignment,
  removePathologistFromTempAssignment,
  removePathologistFromTempUnassignment,
  savePathologistAssignmentsToCase,
  setCaseStatus,
} from '../../redux/actions/CaseActions';
import { AssignPathologistsTableRow } from '..';
import {
  getPathologistsIndexedByKey,
  getAssignedPathologistsIds,
  getArrayOfItemsFromMapByRefKeys,
  createObjectWithPreferredKeysFromArrayOfObjects,
} from '../../helpers';
import {
  ASSIGNED,
  NOT_ASSIGNED,
  SHOULD_BE_ASSIGNED,
  SHOULD_BE_UNASSIGNED,
} from '../../constants/constants';
import { caseStatus, userRoles } from '../../constants';

class AssignPathologistsTable extends Component {
  state = {
    /*  These properties are a bit superflous,
        though they enable easy access to customize
        material-ui:s Table Comp during dev */
    muiTable: {
      fixedHeader: false,
      fixedFooter: false,
      stripedRows: false,
      showRowHover: false,
      selectable: false,
      multiSelectable: false,
      enableSelectAll: false,
      deselectOnClickaway: false,
      showCheckboxes: false,
      adjustForCheckBox: true,
    },
  };

  getCurrentStatusForPathologist = (
    pathologistId,
    assignedPathologists,
    pathologistsToAssign,
    pathologistsToUnassign,
  ) => {
    let currentStatus = NOT_ASSIGNED;

    if (this.shouldBeAssignedToCase(pathologistId, pathologistsToAssign)) {
      currentStatus = SHOULD_BE_ASSIGNED;
    } else if (
      this.shouldBeUnassignedFromCase(pathologistId, pathologistsToUnassign)
    ) {
      currentStatus = SHOULD_BE_UNASSIGNED;
    } else if (this.isAssignedToCase(pathologistId, assignedPathologists)) {
      currentStatus = ASSIGNED;
    }

    return currentStatus;
  }

  /**
   * Dispatch an action creator that - depending on `status` - adds/removes
   * pathologist assignments to a temporary storage in redux store. Does not
   * trigger any POST/PUT/DELETE reqs to the backend.
   *
   * @param {string} pathologistId needs to be a string (MongoDB Object-`_id`) referencing an instance in the Users collection.
   *
   * @param { ASSIGNED | NOT_ASSIGNED | SHOULD_BE_ASSIGNED | SHOULD_BE_UNASSIGNED} status refers to the assignment status of the pathologist in relation to the selectedCase, **BEFORE** the event was triggered.
   */
  updatePathologistAssignmentStatusTemp = (pathologistId, status) => {
    switch (status) {
      case NOT_ASSIGNED:
        this.props.addPathologistToTempAssignment(pathologistId);
        break;
      case SHOULD_BE_ASSIGNED:
        this.props.removePathologistFromTempAssignment(pathologistId);
        break;
      case ASSIGNED:
        this.props.addPathologistToTempUnassignment(pathologistId);
        break;
      case SHOULD_BE_UNASSIGNED:
        this.props.removePathologistFromTempUnassignment(pathologistId);
        break;
      default:
        return console.error('Something went wrong when trying to update assignment status');
    }
    return status;
  }

  isAssignedToCase = (pathologistId, assignedPathologists) =>
    assignedPathologists.includes(pathologistId);

  shouldBeAssignedToCase = (pathologistId, pathologistsToAssign) =>
    pathologistsToAssign.includes(pathologistId);

  shouldBeUnassignedFromCase = (pathologistId, pathologistsToUnassign) =>
    pathologistsToUnassign.includes(pathologistId);

  /**
   * @param {[string]} toAssign Temporarily stored ids that **hopefully** references the `_id` property of the users that should be assigned.
   * @param {[string]} toUnassign Temporarily stored ids that **hopefully** references the `_id` property of the users that should be unassigned.
   * @param {Map<string, object>} pathologistsById All user objects w. role `'pathologist'`, indexed by their `_id` property
   * @param {string} caseId Id of selected case
   */
  submitAssignments = (toAssign, toUnassign, pathologistsById, caseId) => {
    const pathologistsToAssign = getArrayOfItemsFromMapByRefKeys(
      toAssign,
      pathologistsById,
    );

    const pathologistsToUnassign = getArrayOfItemsFromMapByRefKeys(
      toUnassign,
      pathologistsById,
    );

    this.props.savePathologistAssignmentsToCase(
      pathologistsToAssign,
      pathologistsToUnassign,
      caseId,
    );
  }

  assignAllTemp = (
    allPathologists,
    assignedPathologists,
    pathologistsToAssign,
    pathologistsToUnassign,
  ) => {
    const allPathologistIds = Object.values(allPathologists).map((pathologist) => pathologist._id);

    allPathologistIds.map((id) => {
      const status = this.getCurrentStatusForPathologist(
        id,
        assignedPathologists,
        pathologistsToAssign,
        pathologistsToUnassign,
      );

      switch (status) {
        case NOT_ASSIGNED:
          return this.props.addPathologistToTempAssignment(id);
        case SHOULD_BE_UNASSIGNED:
          return this.props.removePathologistFromTempUnassignment(id);
        default:
          return null;
      }
    });
  }

  submitAssignements = () => {
    const {
      pathologistsToAssign,
      pathologistsToUnassign,
      caseId,
      pathologistsById,
    } = this.props;

    this.submitAssignments(
      pathologistsToAssign,
      pathologistsToUnassign,
      pathologistsById,
      caseId,
    );
  }


  render() {
    const {
      allPathologists,
      assignedPathologists,
      pathologistsToAssign,
      pathologistsToUnassign,
      canUpdateAssignedPathologists,
      canSubmitAssignement,
    } = this.props;
    const {
      fixedHeader,
      fixedFooter,
      selectable,
      multiSelectable,
      adjustForCheckBox,
      showCheckboxes,
      enableSelectAll,
      stripedRows,
      showRowHover,
    } = this.state.muiTable;
    return (
      <React.Fragment>
        <Paper zDepth={1} className="form-part-one-specimen-submitted">
          <Table
            fixedHeader={fixedHeader}
            fixedFooter={fixedFooter}
            selectable={selectable}
            multiSelectable={multiSelectable}
          >
            <TableHeader
              adjustForCheckbox={adjustForCheckBox}
              displaySelectAll={showCheckboxes}
              enableSelectAll={enableSelectAll}
            >
              <TableRow>
                <TableHeaderColumn colSpan="2">Name</TableHeaderColumn>
                {/* The type/role row is not a part of the prototype, it is used during development */}
                <TableHeaderColumn>Type</TableHeaderColumn>
                <TableHeaderColumn colSpan="2">Assigned</TableHeaderColumn>   {/* The status row is not a part of the prototype, it is used during development */}
                <TableHeaderColumn>Current status</TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={showCheckboxes}
              showRowHover={showRowHover}
              stripedRows={stripedRows}
            >
              {/* Create a table row for each pathologist */}
              {Object.values(allPathologists).map(({ name, role, _id: pathologistId }, index) => {
                const status = this.getCurrentStatusForPathologist(
                  pathologistId,
                  assignedPathologists,
                  pathologistsToAssign,
                  pathologistsToUnassign,
                );

                return (
                  <AssignPathologistsTableRow
                    key={pathologistId}
                    index={index}
                    canUpdateAssignedPathologists={canUpdateAssignedPathologists}
                    status={status}
                    name={name}
                    role={role}
                    handleClick={() =>
                      this.updatePathologistAssignmentStatusTemp(
                        pathologistId,
                        status,
                      )
                    }
                  />
                );
              })}
            </TableBody>
          </Table>
        </Paper>


        {canUpdateAssignedPathologists && (
          <>
            {/*   <div className="form-part-one-btn-wrapper form-part-one-specimen-submitted">
              <button
                onClick={() =>
                  this.assignAllTemp(
                    allPathologists,
                    assignedPathologists,
                    pathologistsToAssign,
                    pathologistsToUnassign,
                  )
                }
                className="btn--form"
                title="Assign all"
                label="Assign all"
                type="button"
                disabled={!canUpdateAssignedPathologists}
              >
                Assign all
              </button>
            </div> */}
            {canSubmitAssignement && (
              <div className="form-part-one-btn-wrapper form-part-one-specimen-submitted">
                {/*       <button
                  onClick={this.submitAssignements}
                  className="btn--form"
                  title="Save"
                  label="Save"
                  type="button"
                  disabled={!canUpdateAssignedPathologists}
                >
                  Save
                </button> */}

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '4px' }}>
                  <Button
                    onClick={this.submitAssignements}
                    variant="contained"
                    label="Save"
                    style={{ backgroundColor: 'white' }}
                    disabled={!canUpdateAssignedPathologists}

                  >
                    Save
                  </Button>
                </div>
              </div>
            )}
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ _case, auth }) => {
  const {
    cases,
    selectedCase,
    allPathologists,
    pathologistsToAssign,
    pathologistsToUnassign,
  } = _case;
  const { user } = auth;
  const { workFlowStatusDemo: { CASE_CREATED } } = caseStatus;

  const canUpdateAssignedPathologists = user.role === userRoles.admin
    || (user.role === userRoles.surgeon && selectedCase.status.workFlowStatusDemo === CASE_CREATED);
  const canSubmitAssignement = selectedCase.status.workFlowStatusDemo === CASE_CREATED;
  return {
    assignedPathologists: getAssignedPathologistsIds(cases, selectedCase.id),
    allPathologists: createObjectWithPreferredKeysFromArrayOfObjects(allPathologists, '_id'),
    pathologistsToAssign,
    pathologistsToUnassign,
    pathologistsById: getPathologistsIndexedByKey(
      allPathologists,
      ['_id', 'name'],
      '_id',
    ),
    caseId: selectedCase.id,
    canUpdateAssignedPathologists,
    canSubmitAssignement,
  };
};


export default connect(mapStateToProps, {
  setCaseStatus,
  addPathologistToTempAssignment,
  addPathologistToTempUnassignment,
  removePathologistFromTempAssignment,
  removePathologistFromTempUnassignment,
  savePathologistAssignmentsToCase,
})(AssignPathologistsTable);
